import {withProps} from 'recompose'
import {FetchEntityById} from 'views/Shared/components/FetchEntityById'
import {product_getById_Api, shop_getById_Api, shop_getCatalogById_Api} from '../../../../apis'

export const FetchShopById = withProps({
    apiInfo: shop_getById_Api,
})(FetchEntityById)

export const FetchProductCatalogById = withProps({
    apiInfo: shop_getCatalogById_Api,
})(FetchEntityById)

export const FetchProductById = withProps({
    apiInfo: product_getById_Api,
})(FetchEntityById)

